"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionStorage = exports.useLocalStorage = void 0;
var react_1 = require("react");
var useLocalStorage = function (_a) {
    var key = _a.key, schema = _a.schema, def = _a.default;
    var storedValue = def;
    try {
        if (typeof document !== "undefined") {
            var s = localStorage.getItem(key);
            if (s !== null) {
                storedValue = schema.parse(JSON.parse(s));
            }
        }
    }
    catch (err) {
        console.error("Unable to parse stored value for key \"".concat(key, "\""), err);
    }
    var _b = __read((0, react_1.useState)(storedValue), 2), state = _b[0], setState = _b[1];
    var handleSetState = function (value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (err) {
            console.error("Unable to store value in local storage for key ".concat(key), err);
        }
        setState(value);
    };
    return [state, handleSetState];
};
exports.useLocalStorage = useLocalStorage;
var useSessionStorage = function (_a) {
    var key = _a.key, schema = _a.schema, def = _a.default;
    var storedValue = def;
    try {
        if (typeof document !== "undefined") {
            var s = sessionStorage.getItem(key);
            if (s !== null) {
                storedValue = schema.parse(JSON.parse(s));
            }
        }
    }
    catch (err) {
        console.error("Unable to parse stored value for key \"".concat(key, "\""), err);
    }
    var _b = __read((0, react_1.useState)(storedValue), 2), state = _b[0], setState = _b[1];
    var handleSetState = function (value) {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
        catch (err) {
            console.error("Unable to store value in session storage for key ".concat(key), err);
        }
        setState(value);
    };
    return [state, handleSetState];
};
exports.useSessionStorage = useSessionStorage;
